import React, { useEffect, useState } from 'react'
import { Col, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import {
  containerSizeOptionsDefault,
  fatContainerSizeOptions,
  lactoseContainerSizeOptions,
  powderedContainerSizeOptions,
  evaporatedContainerSizeOptions,
  fatReducedMilkTypeOptions,
} from './constants'
import PropTypes from 'prop-types'

const FatReducedMilkPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    ReducedFatMilkType: item.ReducedFatMilkType,
    ReducedFatMilkSize: item.ReducedFatMilkSize,
  })

  const [containerSizeOptions, setContainerSizeOptions] = useState(
    containerSizeOptionsDefault
  )
  const setContainerSize = () => {
    if (
      ['Nonfat', '1% Lowfat', '2% Reduced Fat'].includes(
        item.ReducedFatMilkType
      )
    ) {
      setContainerSizeOptions(fatContainerSizeOptions)
    } else if (
      [
        'Nonfat Lactose Free',
        'Lowfat Lactose Free',
        '2% Reduced Fat Lactose Free',
      ].includes(item.ReducedFatMilkType)
    ) {
      setContainerSizeOptions(lactoseContainerSizeOptions)
    } else if (item.ReducedFatMilkType === 'Nonfat Powdered Dry') {
      setContainerSizeOptions(powderedContainerSizeOptions)
    } else if (item.ReducedFatMilkType === 'Nonfat Evaporated') {
      setContainerSizeOptions(evaporatedContainerSizeOptions)
    }
  }
  const containerSizeReset = () => {
    methods.reset(
      { ReducedFatMilkSize: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { ReducedFatMilkType, ReducedFatMilkSize } = item
      setPackaging({
        ReducedFatMilkType,
        ReducedFatMilkSize,
      })
      setContainerSize()
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Milk Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fatReducedMilkTypeOptions}
          defaultValue={{
            label: packaging.ReducedFatMilkType,
            value: packaging.ReducedFatMilkType,
          }}
          name="ReducedFatMilkType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Milk Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            containerSizeReset()
            setContainerSize()
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ReducedFatMilkType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Size {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={containerSizeOptions}
          name="ReducedFatMilkSize"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          defaultValue={{
            label: packaging.ReducedFatMilkSize,
            value: packaging.ReducedFatMilkSize,
          }}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ReducedFatMilkSize"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

FatReducedMilkPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default FatReducedMilkPackageReview
